import BigNumber from "bignumber.js";
import { LN } from "./ln";

export class LnLookup {
  ln(x: BigNumber) {
    let x1: BigNumber;
    let x2: BigNumber;
    if (x.gt(new BigNumber('2000000000000000000'))) {
      x2 = new BigNumber('2000000000000000000');
      x1 = new BigNumber('1990000000000000000');
    } else if (x.lt(new BigNumber('10000000000000000'))) {
      x1 = new BigNumber('10000000000000000');
      x2 = new BigNumber('20000000000000000');
    } else {
      x1 = x.minus(x.mod('10000000000000000'));
      x2 = x1.plus('10000000000000000');
    }

    if (x1.eq(x)) {
      return new BigNumber(LN[x.toString(10)]);
    }
    const v1 = new BigNumber(LN[x1.toString(10)]);
    const v2 = new BigNumber(LN[x2.toString(10)]);
    return v1.plus(v2.minus(v1).times(x.minus(x1)).divEvm(x2.minus(x1)));
  }
}
